<template>
  <div ref="temporary">
    <div
      v-if="borderTop"
      class="my-0 border-0 border-t border-solid border-gray-500"
      :class="{ '!m-0': borderFull }"
      :style="{
        marginLeft: paddingLeftRight - 1 + 'px',
        marginRight: paddingLeftRight - 1 + 'px',
      }"
    ></div>

    <div
      :style="{
        marginTop: adjustedMarginTop + 'px',
        paddingLeft: paddingLeftRight + 'px',
        paddingRight: paddingLeftRight + 'px',
      }"
    >
      <div
        v-if="header || chip"
        class="flex items-center justify-between"
        :style="{ marginBottom: adjustedHeaderMarginBottom + 'px' }"
      >
        <t-chip
          v-if="chip !== ''"
          :class="{ '!bg-content-1': chipSecondary }"
          >{{ chip }}</t-chip
        >
        <h1
          v-if="header !== ''"
          class="font-inter text-sm font-semibold leading-6 text-gray-50"
        >
          {{ header }}
        </h1>
        <slot name="header-action" />
      </div>

      <slot />
    </div>

    <div
      v-if="borderBottom"
      class="my-0 border-0 border-t border-solid border-gray-500"
      :style="{
        marginTop: marginBottom + 'px',
        marginLeft: paddingLeftRight - 1 + 'px',
        marginRight: paddingLeftRight - 1 + 'px',
      }"
      :class="{ '!mx-0': borderFull }"
    ></div>
  </div>
</template>

<script lang="ts" setup>
  import { TChip } from "@topol/twig-ui";
  import { ref, onMounted } from "vue";

  const props = withDefaults(
    defineProps<{
      header?: string;
      borderBottom?: boolean;
      borderTop?: boolean;
      borderFull?: boolean;
      chip?: string;
      chipSecondary?: boolean;
      marginTop?: number;
      marginBottom?: number;
      headerMarginBottom?: number;
      paddingLeftRight?: number;
    }>(),
    {
      header: "",
      borderBottom: true,
      chip: "",
      marginTop: 12,
      marginBottom: 20,
      headerMarginBottom: 8,
      paddingLeftRight: 10,
    }
  );

  const adjustedMarginTop = ref(props.marginTop);
  const adjustedHeaderMarginBottom = ref(props.headerMarginBottom);

  onMounted(() => {
    if (document.querySelectorAll(".mini").length > 0) {
      adjustedMarginTop.value -= 4;
      adjustedHeaderMarginBottom.value -= 4;
    }
  });
</script>
<style lang="scss"></style>
